<!-- TM-1000002058: section „Beitragsänderungs-Information“ of the billing area (requirement 01 §6.2) -
     metadata-driven CRUD table, the area as fixed filter and as read-only FK default. -->
@if (premiumChangeNoticeTypesWidgetData && initialized) {
    <div class="flex flex-column gap-3">
        <!-- TM-1000002058 G3: the rule of the section as one neutral line -->
        <span class="text-sm text-color-secondary">
            <i class="fa-regular fa-circle-info mr-1"></i>{{ infoText }}
        </span>
        <mvs-widget [widgetData]="premiumChangeNoticeTypesWidgetData"
                    [importObjectContext]="importObjectContext"></mvs-widget>
    </div>
}
